import { auth } from '../firebaseConfig';

// Hands one email to the server (/api/send-email), which sends it through SendGrid.
// The server decides test mode (default ON: everything goes only to the test recipient) and blocks
// any automatic expiration email to a client. Returns { sent, testMode, skipped, reason }.
export const postEmail = async ({ to, cc = [], replyTo = [], subject, html, fromName = '', automated = false, recipientRole = '', name = '', transactionId = null, contactId = null, pipelineId = null, emailType = '' }) => {
  const idToken = await auth.currentUser.getIdToken();
  const res = await fetch('/api/send-email', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
    body: JSON.stringify({ to, cc, replyTo, subject, html, fromName, automated, recipientRole, name, transactionId, contactId, pipelineId, emailType }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) return { sent: false, reason: data.error || `HTTP ${res.status}` };
  return data;
};

// Asks the server to send the deal's "Internal - NEW Contract!" email now (once per deal; the server checks
// the contract date is recent and that it hasn't gone out). Never throws: a failure is left to the daily job.
export const sendUnderContractEmail = async (transactionId) => {
  try {
    const idToken = await auth.currentUser.getIdToken();
    const res = await fetch('/api/under-contract-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
      body: JSON.stringify({ transactionId }),
    });
    return await res.json().catch(() => ({}));
  } catch (e) { return { sent: false, reason: 'error' }; }
};
